export function createUploadProgressItem(file, index) {
  return {
    id: `upload-progress-${Date.now()}-${index}`,
    filename: String(file?.name || '').trim() || String(index + 1),
    progress: 0,
    stage: 'reading',
    error_message: '',
  };
}

export function readFileWithProgress(file, onProgress) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onprogress = (event) => {
      if (!event.lengthComputable) {
        return;
      }
      const percent = (event.loaded / event.total) * 80;
      onProgress(percent);
    };
    reader.onload = () => {
      onProgress(80);
      resolve();
    };
    reader.onerror = () => {
      reject(reader.error || new Error(''));
    };
    reader.readAsArrayBuffer(file);
  });
}
